export const NavigationRoutes = {
    LOGIN: '/login',
    HEADERSETTINGS: '/content-settings',
    DASHBOARD: '/dashboard',
    ABOUT_US: '/about-us',
    CAR_REVIEW: '/car-review',
    VERIFIED_USER_LISTING: '/verified-user-listing',
    DEALER_LISTING: '/dealers',
    ACTIVE_ADMIN: '/active-admin',

    CATEGORIES: '/categories',
    SUB_CATEGORIES: '/categories/:id',
    ATTRIBUTES: '/attributes/:id',
    FORGOT_PASSWORD: '/forgot-password',
    ADMIN_DASHBOARD: '/admin-dashboard',
    DEALER_DASHBOARD: '/dealer-dashboard',

    CREATE_NEW_PASSWORD: "/create-new-password/:token",
    USER_DETAILS: "/user-details/:id",
    PLANS: '/plans',
    TIERS: '/tiers',

    BANKS: '/banks',
    SOLD_ADS: '/sold-ads',
    REMOVED_EXPIRED_ADS: '/removed-expired-ads',

    VEHICLE: '/vehicle',
    SUSPISIOUS: '/suspicious-activity',
    FINANCE: '/finance',

    VEHICLE_MAKE: '/vehicle-make',
    VEHICLE_MODEL: '/vehicle-make/:make_name/:parent_name',
    BLOG: '/blog',
    ADD_BLOG: '/add-blog',
    EDIT_BLOG: '/add-blog/:id',


    ARTICLE: '/article',
    ADD_ARTICLE: '/add-article',
    EDIT_ARTICLE: '/add-article/:id',
    GDPR: '/gdpr',
    PRIVACY_POLICY: '/privacy-policy',
    TERMS_AND_CONDIIONS: '/terms-and-conditions',
    PAYMENT_OPTION: '/payment-option',

    FAQS: '/faqs',
    CONTACTUS: '/contact',
    DATA_REQUEST: '/data-request',

    ADREPORTS: '/ad-reports',


};